<template>
  <section id="about" class="about">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">关于我们</h2>
        <p class="section-subtitle">河北遵睿数字科技有限公司是一家专注于数字技术服务的创新企业</p>
      </div>
      <div class="about-content">
        <div class="about-text">
          <p>
            我们致力于为企业提供全方位、高质量的数字化解决方案，涵盖技术开发、软件销售、大数据服务、数字技术咨询、数据处理以及环保设备销售等多个领域。
          </p>
          <p>
            公司拥有专业的研发团队和丰富的行业经验，以客户需求为导向，以技术创新为驱动，为客户创造长期价值。
          </p>
          <p>
            我们的使命是利用先进数字技术推动产业升级，助力企业实现数字化转型，为社会可持续发展贡献力量。
          </p>
        </div>
        <div class="about-stats">
          <div class="stat-card">
            <div class="stat-label">服务客户</div>
          </div>
          <div class="stat-card">
            <div class="stat-label">项目成功</div>
          </div>
          <div class="stat-card">
            <div class="stat-label">技术专家</div>
          </div>
          <div class="stat-card">
            <div class="stat-label">行业经验</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppAbout'
};
</script>

<style scoped>
.about {
  padding: 5rem 2rem;
  background-color: #f8fafc;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-header {
  text-align: center;
  margin-bottom: 3rem;
}

.section-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1E5AA8;
  margin-bottom: 1rem;
}

.section-subtitle {
  font-size: 1.2rem;
  color: #666;
  max-width: 700px;
  margin: 0 auto;
  line-height: 1.6;
}

.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.about-text p {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #444;
  margin-bottom: 1.5rem;
}

.about-stats {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
}

.stat-card {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  box-shadow: 0 8px 24px rgba(30, 90, 168, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 28px rgba(30, 90, 168, 0.2);
}

.stat-number {
  font-size: 3rem;
  font-weight: 800;
  color: #1E5AA8;
  line-height: 1;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1rem;
  color: #666;
  font-weight: 500;
}

@media (max-width: 992px) {
  .about-content {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
  .about-stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .about {
    padding: 3rem 1.5rem;
  }
  .section-title {
    font-size: 2rem;
  }
  .section-subtitle {
    font-size: 1rem;
  }
  .about-stats {
    grid-template-columns: 1fr;
  }
}
</style>
